//form limits
export const FAVORITES_CHAR_LIMIT = 12;
